import styled from "styled-components";

export const BoxInfoPatientDiv = styled.div`
  background-color: var(--white);
  margin: 5px 0;
  border-radius: 10px;
  padding: 10px;
  position: relative;
  min-width: 700px;
  .boxInfoPatient__header {
    position: relative;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &--left {
      width: 30%;
      justify-content: flex-start;
      .boxInfoPatient__date-left {
        display: none;
      }
    }
    &--center {
      width: 60%;
      justify-content: center;
    }
    &--right {
      width: 30%;
      justify-content: flex-end;
    }
    div {
      display: flex;
    }
    .boxInfoPatient__title {
      display: flex;
      align-items: center;
      div:first-child {
        padding: 2px;
        border-radius: 6px;
        background-color: ${(props) => props.color};
        color: var(--white);
        font-size: 13px;
        height: auto;
      }
      h4 {
        line-height: normal;
        color: ${(props) => props.colorTitle};
        margin-left: 5px;
        font-family: "Nunito Sans ExtraBold";
      }
    }
    .boxInfoPatient__time {
      height: 100%;
      width: 200px;
    }
    .boxInfoPatient__date {
      position: relative;
      display: flex;
      align-items: center;
      font-size: 0.7rem;
      cursor: pointer;
      font-family: "Nunito";
      color: ${(props) => props.colorTitle};
      .boxInfoPatient__text-date {
        align-items: flex-end;
        strong {
          margin: 0 4px;
          font-size: 0.75rem;
        }
      }
      i {
        margin-top: 2px;
        display: flex;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    min-width: auto;
    .boxInfoPatient__header {
      flex-direction: column;
      .boxInfoPatient__header--right {
        width: 100%;
        display: none;
      }
      .boxInfoPatient__header--left {
        width: 100%;
        justify-content: space-between;
        margin-bottom: 15px;
      }
      .boxInfoPatient__header--center {
        width: 100%;
      }
      .boxInfoPatient__date-left {
        display: flex;
      }
    }
  }
`;

export const DateOptions = styled.div`
  position: relative;
  background-color: var(--white);
  height: 120px;
  width: 145px;
  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-date {
    font-size: 0.75rem;
    color: ${(props) => props.color} !important;
    cursor: pointer;
    padding: 5px 10px;
  }
`;
